import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import { Document, Page, pdfjs } from 'react-pdf'
import ControlPanel from './ControlPanel'
import 'react-pdf/dist/esm/Page/TextLayer.css'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
import Loading from '../common/Loading'

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`

const PDFReader = ({ url, filename }) => {
  const [scale, setScale] = useState(1.0)
  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    setIsLoading(true)
    setPageNumber(1)
  }, [url])

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages)
    setIsLoading(false)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          flexShrink: 0,
          paddingTop: '10px',
          paddingBottom: '20px'
        }}
      >
        <ControlPanel
          scale={scale}
          setScale={setScale}
          numPages={numPages}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          file={url}
          filename={filename}
        />
      </Box>

      <Box
        sx={{
          flex: '1 1 0%',
          overflowY: 'auto',
          width: '100%',
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            paddingTop: '20px',
            paddingBottom: '20px'
          }}
        >
          <Document
            loading={<Loading />}
            file={url}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={(error) => {
              setIsLoading(false)
            }}
          >
            <Page pageNumber={pageNumber} scale={scale} />
          </Document>
        </Box>
      </Box>
    </Box>
  )
}

export default React.memo(PDFReader)
